export const manifest = {
  screens: {
    scr_0c017q: { name: "Splash", route: "/splash", position: {"x":160,"y":2200} },
    scr_k123jq: { name: "Welcome", route: "/welcome", position: {"x":1560,"y":2200} },
    scr_e4mjn5: { name: "Select User Type", route: "/select-user-type", position: {"x":160,"y":4180} },
    scr_6axupk: { name: "Login", route: "/login", position: {"x":1560,"y":4180} },
    scr_cksg4o: { name: "Forgot Password", route: "/forgot-password", position: {"x":2960,"y":4180} },
    scr_s2mf8t: { name: "OTP Verification", route: "/otp", position: {"x":4360,"y":4180} },
    scr_nqb5u7: { name: "Create Password", route: "/create-password", position: {"x":5760,"y":4180} },
    scr_q8qy6e: { name: "Terms & Conditions", route: "/terms", position: {"x":7160,"y":4180} },
    scr_369gir: { name: "Onboarding: Personal Info", route: "/onboarding", state: {"step":1}, position: {"x":160,"y":6160} },
    scr_roco4r: { name: "Onboarding: Contact", route: "/onboarding", state: {"step":2}, position: {"x":1560,"y":6160} },
    scr_mvx4c5: { name: "Onboarding: Address", route: "/onboarding", state: {"step":3}, position: {"x":2960,"y":6160} },
    scr_czyujn: { name: "Onboarding: GPS Location", route: "/onboarding", state: {"step":4}, position: {"x":4360,"y":6160} },
    scr_5zpkmr: { name: "Onboarding: Upload Passport", route: "/onboarding", state: {"step":5}, position: {"x":5760,"y":6160} },
    scr_0brdhu: { name: "Onboarding: Upload National ID", route: "/onboarding", state: {"step":6}, position: {"x":7160,"y":6160} },
    scr_8f8xvq: { name: "Onboarding: Guarantor", route: "/onboarding", state: {"step":7}, position: {"x":8560,"y":6160} },
    scr_3czmpl: { name: "Onboarding: Skills", route: "/onboarding", state: {"step":8}, position: {"x":9960,"y":6160} },
    scr_k9t25j: { name: "Onboarding: Business Sector", route: "/onboarding", state: {"step":9}, position: {"x":11360,"y":6160} },
    scr_lsxw3h: { name: "Onboarding: Business Description", route: "/onboarding", state: {"step":10}, position: {"x":12760,"y":6160} },
    scr_9lvrdh: { name: "Onboarding: Support Needs", route: "/onboarding", state: {"step":11}, position: {"x":14160,"y":6160} },
    scr_strek4: { name: "Onboarding: Complete", route: "/onboarding", state: {"step":12}, position: {"x":15560,"y":6160} },
    scr_w1t4u7: { name: "Home", route: "/app", position: {"x":160,"y":220} },
    scr_0du937: { name: "Marketplace", route: "/app/marketplace", position: {"x":1560,"y":220} },
    scr_b2ig1v: { name: "Training", route: "/app/training", position: {"x":2960,"y":220} },
    scr_j68oaf: { name: "Messages", route: "/app/messages", position: {"x":4360,"y":220} },
    scr_ltyd2r: { name: "Profile", route: "/app/profile", position: {"x":5760,"y":220} },
  },
  sections: {
    sec_vl0ugu: { name: "Main app navigation", x: 0, y: 0, width: 7120, height: 1180 },
    sec_d7258b: { name: "Splash & Welcome", x: 0, y: 1980, width: 2920, height: 1180 },
    sec_su22yj: { name: "Authentication", x: 0, y: 3960, width: 8520, height: 1180 },
    sec_0ihoo3: { name: "Onboarding flow", x: 0, y: 5940, width: 16920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_vl0ugu", children: [
      { kind: "screen", id: "scr_w1t4u7" },
      { kind: "screen", id: "scr_0du937" },
      { kind: "screen", id: "scr_b2ig1v" },
      { kind: "screen", id: "scr_j68oaf" },
      { kind: "screen", id: "scr_ltyd2r" },
    ] },
    { kind: "section", id: "sec_d7258b", children: [
      { kind: "screen", id: "scr_0c017q" },
      { kind: "screen", id: "scr_k123jq" },
    ] },
    { kind: "section", id: "sec_su22yj", children: [
      { kind: "screen", id: "scr_e4mjn5" },
      { kind: "screen", id: "scr_6axupk" },
      { kind: "screen", id: "scr_cksg4o" },
      { kind: "screen", id: "scr_s2mf8t" },
      { kind: "screen", id: "scr_nqb5u7" },
      { kind: "screen", id: "scr_q8qy6e" },
    ] },
    { kind: "section", id: "sec_0ihoo3", children: [
      { kind: "screen", id: "scr_369gir" },
      { kind: "screen", id: "scr_roco4r" },
      { kind: "screen", id: "scr_mvx4c5" },
      { kind: "screen", id: "scr_czyujn" },
      { kind: "screen", id: "scr_5zpkmr" },
      { kind: "screen", id: "scr_0brdhu" },
      { kind: "screen", id: "scr_8f8xvq" },
      { kind: "screen", id: "scr_3czmpl" },
      { kind: "screen", id: "scr_k9t25j" },
      { kind: "screen", id: "scr_lsxw3h" },
      { kind: "screen", id: "scr_9lvrdh" },
      { kind: "screen", id: "scr_strek4" },
    ] },
  ],
}
